import { Button, CircularProgress, MenuItem, TextField } from "@mui/material";
import CustomTextField from "../../../components/OB/required-text-field";
import { Form, Formik, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import DocumentTable from "../../../components/OB/BelgeYukleme";

import { useNavigate } from "react-router-dom";
import { year } from "../../../helpers/TodayDate";
import FaaliyetListeAPI from "../../../apis/OB/Get/FaaliyetListeAPI";
import SessionStorageService from "../../../services/StorageService";
import EhgsBasvuruSave from "../../../apis/OB/SaveApi/EhgsBasvuruSave";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import EhgtGelirTuruAPI from "../../../apis/OB/Get/EhgtGelirTuruAPI";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import { toast } from "react-toastify";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import DysAPI from "../../../apis/DysAPI";
import Recaptcha from "../../../components/Recaptcha";

const validationSchema = Yup.object().shape({
  beyanYili: Yup.number().required('Beyan Yılı zorunludur'),
  beyanAyi: Yup.number().required('Beyan Ayı zorunludur'),
  faaliyetKodu: Yup.number().required('faaliyet zorunludur'),
  mahalleKodu: Yup.number().required('Mahalle zorunludur'),
  caddeSokakKodu: Yup.number().required('Cadde/Sokak zorunludur'),
  kapiNo: Yup.string().required('Kapı No zorunludur'),
  butceGelirId: Yup.number().required("Vergi adı zorunludur")
});

const EhgtBasvuru = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const { yilListe, mahalleListe } = useContext(ConstantAPISContext);
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(null);
  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  const [faaliyetListe, setFaaliyetListe] = useState<any[]>([]);
  const [isLoad, setIsLoad] = useState(true);
  const navigate = useNavigate();
  let user = SessionStorageService.getUserInfo()
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };
  const [userControlPopup, setUserControlPopup] = useState(false);
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  useEffect(() => {

    if (user == null) {

      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }

  }, []);
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };

  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 7 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);
  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);

  const [gelirTuruList, setGelirTuruList] = useState([] as any[]);

  useEffect(() => {
    if (user) {
      FaaliyetListeAPI.getFaaliyetListe(undefined)
        .then((res) => {
          console.log(res.data)
          setFaaliyetListe(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
      EhgtGelirTuruAPI.getEhgtvGelirTuru(year, undefined).then((response) => {
        setGelirTuruList(response.data);
      }).catch((error) => {
      });
    }
  }, []);



  return (
    isLoad ? <>
      <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
      {userControlPopup ? (

        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />

      ) : null}
    </> : <Formik
      initialValues={{
        basvuruTuruId: 7,
        sicilKodu: user?.sicilKodu,
        beyanYili: year,
        beyanAyi: "",
        mahalleKodu: null,
        caddeSokakKodu: null,
        kapiNo: "",
        faaliyetKodu: null,
        butceGelirId: null,
        altDaireNo: "",
        altKapiNo: "",
        daireNo: "",
        vergiTabiOlmynSatisBedel: "",
        satisBedeli: "",
        donemIadeTutari: "",
        aciklama: "",
      }}
      validationSchema={validationSchema}
      validateOnMount={true}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }

        setLoadingSubmit(true);
        const transformedValues = {
          ...values,
          sicilKodu: safelyParseNumber(values.sicilKodu) || 0,
          kapiNo: Number(values.kapiNo),
          beyanYili: Number(values.beyanYili),
          beyanAyi: Number(values.beyanAyi),
          mahalleKodu: Number(values.mahalleKodu),
          caddeSokakKodu: Number(values.caddeSokakKodu),
          butceGelirId: values.butceGelirId ? Number(values.butceGelirId) : null,
          faaliyetKodu: values.faaliyetKodu ? Number(values.faaliyetKodu) : null,
          daireNo: values.daireNo ? Number(values.daireNo) : null,
          satisBedeli: values.satisBedeli ? Number(values.satisBedeli) : null,
          vergiTabiOlmynSatisBedel: values.vergiTabiOlmynSatisBedel ? Number(values.vergiTabiOlmynSatisBedel) : null,
          donemIadeTutari: values.donemIadeTutari ? Number(values.donemIadeTutari) : null,
          captchaToken: token
        };
        EhgsBasvuruSave.saveEhgsBasvuruSave(transformedValues)
          .then(async (res) => {
            console.log(res);
            if (res.data.sonuc === 0) {
              let basvuruNo = res.data.basvuruNo;

              // DYS API'yi çağır 
              try {
                // Sadece dosyası olanları al
                const filesToSend = documents.filter((doc: any) => !!doc.file);

                if (filesToSend.length > 0) {
                  const formData = new FormData();

                  filesToSend.forEach((doc: any) => {
                    formData.append("files", doc.file, doc.file.name);
                    formData.append("rfObBasvuruTanimBelge", String(doc.id));
                  });

                  formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                  formData.append("basvuruId", String(basvuruNo));
                  formData.append("folderName", "AKOS");
                  formData.append("kurumId", "1");
                  formData.append("versionable", "1");

                  const response = await DysAPI.upload(formData);
                  toast.warning(response.message);
                } else {
                  // Burada return yok — sadece DYS çağrısını atlıyoruz.
                  
                }
              } catch (error: any) {
                toast.error("DYS upload hazırlama hatası:", error);
              }

              setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
              resetForm();
              setKayitBasarili(true);
              setDocuments((prevDocs: any[]) =>
                prevDocs.map((doc) => ({
                  ...doc,
                  file: null,
                  fileName: "",
                }))
              );
            } else {
              setPopupAciklama(res.data.sonucAciklama);
            }
          })
          .catch((err) => {
            setPopupAciklama(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
          });
        // API'ye istek gönderme işlemi
        console.log("Gönderilen Request Model:", transformedValues);
      }}
    >
      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");

          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };
        return (
          <Form>
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          size="small"
                          name="beyanYili"
                          select
                          label="Beyan Yılı *"
                          error={formikProps.errors.beyanYili && formikProps.touched.beyanYili}
                        >
                          <MenuItem value="">
                            {"Seçiniz.."}
                          </MenuItem>
                          {yilListe.map((option) => (
                            <MenuItem key={option.yili} value={option.yili}>
                              {option.yili}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          select
                          size="small"
                          label="Beyan Ayı *"
                          name="beyanAyi"
                          error={formikProps.touched.beyanAyi && !!formikProps.errors.beyanAyi}
                        >
                          <MenuItem value="">Seçiniz..</MenuItem>
                          <MenuItem value={1}>Ocak</MenuItem>
                          <MenuItem value={2}>Şubat</MenuItem>
                          <MenuItem value={3}>Mart</MenuItem>
                          <MenuItem value={4}>Nisan</MenuItem>
                          <MenuItem value={5}>Mayıs</MenuItem>
                          <MenuItem value={6}>Haziran</MenuItem>
                          <MenuItem value={7}>Temmuz</MenuItem>
                          <MenuItem value={8}>Ağustos</MenuItem>
                          <MenuItem value={9}>Eylül</MenuItem>
                          <MenuItem value={10}>Ekim</MenuItem>
                          <MenuItem value={11}>Kasım</MenuItem>
                          <MenuItem value={12}>Aralık</MenuItem>
                        </Field>

                      </div>
                      <div className="col-md-6 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          size="small"
                          name="faaliyetKodu"
                          select
                          label="Faaliyet Adı *"
                          error={formikProps.errors.faaliyetKodu && formikProps.touched.faaliyetKodu}
                        >
                          <MenuItem value="">
                            {"Seçiniz.."}
                          </MenuItem>
                          {faaliyetListe.map((option) => (
                            <MenuItem key={option.faaliyetKodu} value={option.faaliyetKodu}>
                              {option.faaliyetAdi}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          select
                          label="Mahalle *"
                          size="small"
                          name="mahalleKodu"
                          error={formikProps.errors.mahalleKodu && formikProps.touched.mahalleKodu}
                          onChange={(event: any) => {
                            formikProps.setFieldValue("mahalleKodu", Number(event.target.value));
                            setSelectedMahalleKodu(Number(event.target.value));
                            formikProps.setFieldValue("caddeSokakKodu", "");
                          }}
                        >
                          <MenuItem value="">
                            {"Seçiniz.."}
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem key={option.mahalleKodu} value={option.mahalleKodu}>
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          size="small"
                          name="caddeSokakKodu"
                          select
                          label="Cadde/Sokak *"
                          error={formikProps.errors.caddeSokakKodu && formikProps.touched.caddeSokakKodu}
                        >
                          <MenuItem value="">
                            {"Seçiniz.."}
                          </MenuItem>
                          {caddeListe.map((option) => (
                            <MenuItem key={option.caddeSokakKodu} value={option.caddeSokakKodu}>
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          size="small"
                          name="kapiNo"
                          label="Kapı No *"
                          error={formikProps.errors.kapiNo && formikProps.touched.kapiNo}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Alt Kapı No"
                          name="altKapiNo"
                          error={formikProps.errors.altKapiNo && formikProps.touched.altKapiNo}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Daire No"
                          name="daireNo"
                          error={formikProps.errors.daireNo && formikProps.touched.daireNo}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Alt Daire No"
                          name="altDaireNo"
                          error={formikProps.errors.altDaireNo && formikProps.touched.altDaireNo}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <Field
                          as={CustomTextField}
                          fullWidth
                          select
                          label="Vergi Adı *"
                          size="small"
                          name="butceGelirId"
                          error={formikProps.errors.butceGelirId && formikProps.touched.butceGelirId}
                        >
                          <MenuItem value="">
                            {"Seçiniz.."}
                          </MenuItem>
                          {gelirTuruList.map((option) => (
                            <MenuItem key={option.butceGelirId} value={option.butceGelirId}>
                              {option.butceGelirAdi}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="col-12 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Satış Bedeli"
                          name="satisBedeli"
                          error={formikProps.errors.satisBedeli && formikProps.touched.satisBedeli}
                        />
                      </div>
                      <div className="col-12 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Vergiye Tabi Olmayan Satış Bedeli"
                          name="vergiTabiOlmynSatisBedel"
                          error={formikProps.errors.vergiTabiOlmynSatisBedel && formikProps.touched.vergiTabiOlmynSatisBedel}
                        />
                      </div>
                      <div className="col-12 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Dönem İade Tutarı"
                          name="donemIadeTutari"
                          error={formikProps.errors.donemIadeTutari && formikProps.touched.donemIadeTutari}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <Field
                          as={TextField}
                          fullWidth
                          size="small"
                          label="Açıklama"
                          multiline
                          rows={8.2}
                          name="aciklama"
                          error={formikProps.errors.aciklama && formikProps.touched.aciklama}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="d-flex justify-content-end align-self-stretch mt-3">
                <Recaptcha
                  ref={recaptchaRef}
                  changeHandleRecaptcha={setRecaptchaPassed}
                />
                <Button
                  onClick={() => showToastIfErrorsExist()}

                  type="submit"

                >
                  Gönder
                </Button>
                {loadingSubmit && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(255,255,255,0.6)",
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
            {isPopupVisible ? (
              <BilgilendirmePopup
                basvuruTuruId={formikProps.values.basvuruTuruId}
                isSorunBildirPopup={!kayitBasarili}
                closePopup={closePopupSonuc}
                open={isPopupVisible}
                editDescription={popupAciklama}
              />
            ) : null}
          </Form>
        )
      }}
    </Formik>
  );
};

export default EhgtBasvuru;
